import React from 'react';
import classes from './ButtonCall.module.css'

const ButtonCall = props => {
    return (
        <button
            className={`${classes.buttonCall} ${props.isActive || false ? classes.buttonCallActive : ''}`}
            onClick={props.onClick}
        >{props.children}
        </button>
    );
};
export default ButtonCall